import { render, staticRenderFns } from "./ListStudentNeedSupport.vue?vue&type=template&id=6130a870&scoped=true&lang=pug&"
import script from "./ListStudentNeedSupport.vue?vue&type=script&lang=ts&"
export * from "./ListStudentNeedSupport.vue?vue&type=script&lang=ts&"
import style0 from "./ListStudentNeedSupport.vue?vue&type=style&index=0&id=6130a870&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130a870",
  null
  
)

export default component.exports